import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  pdfSrc = '';
  hideDownload = false;
  showLoading = false;
  showTips = false;
  tipsMessage = '';

  getUrl = '/api/v1/record/reportlink/';
   name = '';
   report_name = '';
   report_num = '';
  constructor(
    public http: HttpClient
  ) { }

  ngOnInit(): void {
    (window as any).pdfWorkerSrc = 'assets/js/pdf.worker.min.js';
    this.initWeixinFontSize();

    let list = location.href.split('?');
    let search = '';
    if (list.length > 1) {
      search = list[1];
    }
    let arr = search.split('&');
    let obj: any = {};
    arr.forEach(item => {
      let key = item.split('=')[0];
      let value = item.split('=')[1];
      if (key) {
        obj[key] = value;
      }
    });

    this.hideDownload = obj.hideDownload === 'true' ? true : false;
    if (obj.code_param) {
      this.http.get(`${this.getUrl}?code=${obj.code_param}`).subscribe((res: any) => {
        if (res.status) {
          this.pdfSrc = decodeURIComponent(res.data.download_url);
          this.name = res.data.name;
          this.report_name = res.data.report_name;
          this.report_num = res.data.report_num;
          this.showLoading = true;
        } else {
          this.showTipsHandle('报告获取失败');
          // 隐藏下载按钮
          this.hideDownload = true;
        }
      }
    );
    } else if (obj.url) {
      this.pdfSrc = decodeURIComponent(obj.url);
      this.showLoading = true;
    } else {
      this.showTipsHandle('报告获取失败');
      // 隐藏下载按钮
      this.hideDownload = true;
    }
  }
  initWeixinFontSize() {
    // @ts-ignore
    if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
      this.handleFontSize();
    } else {
      document.addEventListener('WeixinJSBridgeReady', () => this.handleFontSize(), false);
    }
  }
  handleFontSize() {
    console.log('设置后h5')
    // @ts-ignore
    WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
    // @ts-ignore
    WeixinJSBridge.on('menu:setfont', function() {
      // @ts-ignore
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
    });
}
  onPdfProgress(progress: any) {
    console.log(progress);
    // this.showLoading = true;
  }
  onPdfComplete(res: any) {
    console.log(res);
    this.showLoading = false;
  }
  onPdfError(err: any) {
    console.log(err);
    this.showLoading = false;
    this.showTipsHandle('报告获取失败');

    // 隐藏下载按钮
    this.hideDownload = true;
  }
  showTipsHandle(message: string) {
    this.showTips = true;
    this.tipsMessage = message;

    setTimeout(() => {
      this.showTips = false;
    }, 2000)
  }
  downloadPdf() {
    if(this.name && this.report_num && this.report_name) {
      window.open( '/api/v1/file/download/rename/' + `?url=${this.pdfSrc}&rename=${this.name}-${this.report_num}-${this.report_name}`)
    } else {
      window.open(this.pdfSrc);
    }
  }
}
